module.exports = __webpack_public_path__ + "static/media/draft2digital.d44e8cb3.svg";